import { Spreadsheet, getRangeAddress, setColMinWidth } from '@syncfusion/ej2-spreadsheet';
import { Uploader } from '@syncfusion/ej2-inputs';
import { ExcelWorksheetCellModel, ExcelWorksheetModel, SetWorkbookDataModel } from '../../Models/Excel/SetWorkbookDataModel';
import { ExcelDataService } from '../../DataService/ExcelDataService';
import { DataWarehouseDataService } from '../../DataService/DataWarehouseDataService';

import { Grid, Filter, Page, Sort, RecordClickEventArgs, parentsUntil, Toolbar, Scroll, Column } from '@syncfusion/ej2-grids';
import { Query, DataManager, WebApiAdaptor } from '@syncfusion/ej2-data';
import { Tooltip, TooltipEventArgs } from '@syncfusion/ej2-popups';
import { classList, closest } from '@syncfusion/ej2-base';
import { ModalHelper } from '../../Helpers/ModalHelper';
import { Toastr } from '../../Helpers/Toastr';
import { DropDownList } from '@syncfusion/ej2/dropdowns';
import { DataWarehouseSources } from '../../Models/DataWarehouse/DataWarehouseSources';
import { DataWarehouseDocumentTypes } from '../../Models/DataWarehouse/DataWarehouseDocumentTypes';
import { DocHeaderStatus } from '../../Models/DataWarehouse/DocHeaderStatus';
import { DocHeaderFilterStatus } from '../../Models/DataWarehouse/DocHeaderFilterStatus';
import { AddManualProjectManager } from './AddManualProjectManager';
import { OfferProcureShipRfqManager } from './ProcureShip/OfferProcureShipRfqManager';
import { WorkloadManagerDataService } from '../../DataService/WorkloadManagerDataService';
import { SyncfusionDropdownHelper } from '../../Helpers/SyncfusionDropdownHelper';
import { SyncfusionGridHelper } from '../../Helpers/SyncfusionGridHelper';
import { CreateCustomerXrefManager } from './CreateCustomerXrefManager';
import { CreateVesselXrefManager } from './CreateVesselXrefManager';
import { CreateDepartmentXrefManager } from './CreateDepartmentXrefManager';
import { DynamicVariables } from '../../Common/DynamicVariables';
import { ConfirmModal } from '../../Helpers/ConfirmModal';
import { CommonDataService } from '../../DataService/CommonDataService';
import { CompanyPlugin } from '../../Models/Common/CompanyPlugin';
import Dropdown from 'bootstrap/js/dist/dropdown';
import { AddOrUpdateTaskPopupManager } from '../../Exporters/ManagersExporter';

export class DataWarehouseIndexManager {

    constructor(private containerElement: JQuery) { }

    private workbookGrid : Grid;

    private addManualProjectModalHelper : ModalHelper;
    private addManualProjectManager : AddManualProjectManager;

    private vesselXrefModalHelper : ModalHelper;    
    private createVesselXrefManager : CreateVesselXrefManager;    

    private customerXrefModalHelper : ModalHelper;    
    private createCustomerXrefManager : CreateCustomerXrefManager;    
    
    private departmentXrefModalHelper : ModalHelper;    
    private createDepartmentXrefManager : CreateDepartmentXrefManager;    

    private addTaskModalHelper : ModalHelper;
    private addTaskManager : AddOrUpdateTaskPopupManager;

    public initialize() {
        var self = this;

        Grid.Inject(Filter, Page, Sort, Toolbar, Scroll);

        self.initializeDataWarehouseDocumentsTable();
    }

    private initializeDataWarehouseDocumentsTable() {
        var self = this;

        var loadingContainer = self.containerElement.find('#loading-container');
        var dataWarehouseItemsContainer = self.containerElement.find('#data-warehouse-items-container');

        var gridElement : JQuery<HTMLElement> = self.containerElement.find('#DataWarehouseGrid');
        var gridContentElement : JQuery<HTMLElement> = gridElement;

        var assignedToMeCheckbox = self.containerElement.find('#assigned-to-me-checkbox');
        var overdueOnlyChecked = self.containerElement.find('#only-overdue-checkbox');
        var showDiscardedCheckbox = self.containerElement.find('#show-discarded-checkbox');

        self.addManualProjectModalHelper = new ModalHelper();
        self.addManualProjectModalHelper.createModal("add-manual-project-popup", true);

        this.vesselXrefModalHelper = new ModalHelper();
        this.vesselXrefModalHelper.createModal("vessel-xref-popup", true);

        this.customerXrefModalHelper = new ModalHelper();
        this.customerXrefModalHelper.createModal("customer-xref-popup", true);        
        
        this.departmentXrefModalHelper = new ModalHelper();
        this.departmentXrefModalHelper.createModal("department-xref-popup", true);

        self.addTaskModalHelper = new ModalHelper();
        self.addTaskModalHelper.createModal("add-or-update-task-popup", true);

        let data: DataManager = new DataManager({
            url: '/api/company/datawarehouse/documents',
            adaptor: new WebApiAdaptor,
        }); 

        DataWarehouseDataService.getDataWarehouseIndexModel((result) => {

            var dataSources = result.dataSources;

            var columns : any = [
                { field: 'Id', isPrimaryKey: true, visible: false, allowEditing: false, validationRules: { required: true }},
                { field: 'AssignedToMe',visible: false},
                { field: 'OnlyOverdue',visible: false},
                { field: 'ShowDiscarded',visible: false},
                { field: 'CreationDateTimeString', headerText: 'Created', allowFiltering: false, width: 90, autoFit: true},
                { field: 'CreatedByInitials', headerText: '', allowFiltering: false, width: 40, autoFit: true,
                    template: '${getCreatedByTemplate(data.CreatedBy, data.CreatedByInitials)}'
                },
                { field: 'DataSource', allowSorting: false, headerText: 'Source', width: 110, 
                    filterBarTemplate: SyncfusionDropdownHelper.templateEnumOptionsDropDown(() => this.workbookGrid, 'DataSource', dataSources, 
                    (args) => {
                    if (args.value !== 'All') {
                        self.workbookGrid.filterByColumn(args.item.parentElement.id.replace('_options', ''), 'equal', args.value, undefined, true);
                    } else {
                        self.workbookGrid.removeFilteredColsByField(args.item.parentElement.id.replace('_options', ''));
                    }
                })},
                { field: 'DocType', allowSorting: false, headerText: 'Type', autoFit: true,allowFiltering: true, width: 60 },
                { field: 'Deparment', headerText: 'Dept.', autoFit: true,allowFiltering: false, width: 95},
                { field: 'CustomerName', headerText: 'Customer',  width: 220},
                { field: 'VesselName', headerText: 'Vessel', width: 180},
                { field: 'LineCount', headerText: '#', allowFiltering: false, width: 75, textAlign: 'right'},
            ];

            if(DynamicVariables.TaskmanagerEnabled) {
                columns.push( 
                { 
                    field: 'TaskCount', headerTemplate: '<i title="Tasks" class="fa-solid fa-clipboard"></i>', allowSorting: false, allowFiltering: true, width: 30, textAlign: 'center', 
                    filterBarTemplate: {
                        create: () => { 
                            var docHeadersWithTasksCheckboxDiv = document.createElement("div");
                            docHeadersWithTasksCheckboxDiv.classList.add('d-flex')

                            var docHeaderWithTaskCheckbox = document.createElement("input");
                            docHeaderWithTaskCheckbox.type = "checkbox";
                            docHeaderWithTaskCheckbox.style.width = '13px';
                            docHeaderWithTaskCheckbox.style.height = '13px';
                            docHeaderWithTaskCheckbox.classList.add('mx-auto');

                            docHeadersWithTasksCheckboxDiv.append(docHeaderWithTaskCheckbox);

                            var parsedDocHeadersWithTaskCheckbox = $(docHeaderWithTaskCheckbox);
                            parsedDocHeadersWithTaskCheckbox.data('bs-toggle', 'tooltip');
                            parsedDocHeadersWithTaskCheckbox.prop('title', 'Show enquiries with tasks');

                            parsedDocHeadersWithTaskCheckbox.tooltip({ container: 'body', trigger: 'hover' });

                            parsedDocHeadersWithTaskCheckbox.off('change').on('change', () => {
                                self.workbookGrid.filterByColumn('TaskCount', 'equal', parsedDocHeadersWithTaskCheckbox.is(':checked'), undefined, true);
                            })

                            return docHeadersWithTasksCheckboxDiv;
                        }, 
                        write: (args) => {
                            const persistedValue =
                                args?.value
                                ?? self.workbookGrid?.filterSettings?.columns
                                    ?.find((x: any) => x.field === 'TaskCount')
                                    ?.value;

                            const filterCell = args.element as HTMLElement;
                            const checkbox = filterCell.querySelectorAll<HTMLInputElement>('input[type="checkbox"]');

                            checkbox[0].checked =
                                persistedValue === true || persistedValue === 'true';
                        }
                    },
                })
            }

            columns.push(
            { 
                field: 'ERP', headerText: 'ERP', allowSorting: false, allowFiltering: true, width: result.erpDepartmentsEnabled ? 70 : 60,
                filterBarTemplate: {
                    create: () => { 
                        var erpCheckboxesDiv = document.createElement("div");
                        erpCheckboxesDiv.classList.add('d-flex');

                        var unlinkedDepartmentsCheckbox = document.createElement("input");
                        unlinkedDepartmentsCheckbox.type = "checkbox";
                        unlinkedDepartmentsCheckbox.style.width = '13px';
                        unlinkedDepartmentsCheckbox.style.height = '13px';

                        if(!result.erpDepartmentsEnabled) {
                            unlinkedDepartmentsCheckbox.style.display = 'none';
                        }

                        erpCheckboxesDiv.append(unlinkedDepartmentsCheckbox);

                        var unlinkedCustomersCheckbox = document.createElement("input");
                        unlinkedCustomersCheckbox.type = "checkbox";
                        unlinkedCustomersCheckbox.style.width = '13px';
                        unlinkedCustomersCheckbox.style.height = '13px';

                        if(result.erpDepartmentsEnabled) {
                            unlinkedCustomersCheckbox.style.marginLeft = '1rem';
                        }

                        erpCheckboxesDiv.append(unlinkedCustomersCheckbox);

                        var unlinkedVesselsCheckbox = document.createElement("input");
                        unlinkedVesselsCheckbox.type = "checkbox";
                        unlinkedVesselsCheckbox.style.width = '13px';
                        unlinkedVesselsCheckbox.style.height = '13px';
                        unlinkedVesselsCheckbox.style.marginLeft = '1rem';

                        erpCheckboxesDiv.append(unlinkedVesselsCheckbox);

                        var parsedDepartmentsCheckbox = $(unlinkedDepartmentsCheckbox);
                        parsedDepartmentsCheckbox.data('bs-toggle', 'tooltip');
                        parsedDepartmentsCheckbox.prop('title', 'Show enquiries without a linked ERP department');

                        var parsedCustomersCheckbox = $(unlinkedCustomersCheckbox);
                        parsedCustomersCheckbox.data('bs-toggle', 'tooltip');
                        parsedCustomersCheckbox.prop('title', 'Show enquiries without a linked ERP customer');

                        var parsedVesselsCheckbox = $(unlinkedVesselsCheckbox);
                        parsedVesselsCheckbox.data('bs-toggle', 'tooltip');
                        parsedVesselsCheckbox.prop('title', 'Show enquiries without a linked ERP vessel');

                        parsedCustomersCheckbox.tooltip({ container: 'body', trigger: 'hover' });
                        parsedVesselsCheckbox.tooltip({ container: 'body', trigger: 'hover' });

                        var updateErpCheckboxFunc = () => {
                            var showUnlinkedCustomers = parsedCustomersCheckbox.is(':checked');
                            var showUnlinkedVessels = parsedVesselsCheckbox.is(':checked');
                            var showUnlinkedDepartments = parsedDepartmentsCheckbox.is(':checked');
                            self.workbookGrid.filterByColumn('ERP', 'equal', `${showUnlinkedCustomers}|${showUnlinkedVessels}|${showUnlinkedDepartments}`, undefined, true);
                        }

                        parsedDepartmentsCheckbox.off('change').on('change', () => {
                            updateErpCheckboxFunc();
                        })

                        parsedCustomersCheckbox.off('change').on('change', () => {
                            updateErpCheckboxFunc();
                        })

                        parsedVesselsCheckbox.off('change').on('change', () => {
                            updateErpCheckboxFunc();
                        })

                        return erpCheckboxesDiv;
                    }, 
                    write: (args) => {
                        const filterValue =
                            args?.value?.toString()
                            ?? self.workbookGrid?.filterSettings?.columns
                                ?.find((x: any) => x.field === 'ERP')
                                ?.value
                                ?.toString();

                        if (!filterValue) {
                            return;
                        }

                        const [showUnlinkedCustomers, showUnlinkedVessels, showUnlinkedDepartments] = filterValue
                            .split('|')
                            .map(x => x === 'true');

                        const filterCell = args.element as HTMLElement;

                        const checkboxes = filterCell.querySelectorAll<HTMLInputElement>('input[type="checkbox"]');

                        if (checkboxes.length >= 2) {
                            checkboxes[0].checked = showUnlinkedDepartments;
                            checkboxes[1].checked = showUnlinkedCustomers;
                            checkboxes[2].checked = showUnlinkedVessels;
                        }
                    }
                },
                
                template: '${getDocHeaderErpActions(data.Id, data.Status, data.CanProcess, data.ErpSourceVesselXrefSet, data.ErpSourceCustomerXrefSet, data.CanCreateErpSourceDepartmentXref, data.ErpSourceDepartmentXrefSet)}'},
                { field: 'CustomerReference', headerText: 'Cust. ref.', autoFit: true, allowFiltering: true, width: 135 },
                { field: 'OurReference', headerText: 'Our. ref.', autoFit: true, allowFiltering: true, width: 70 }
            );

            if(result.workloadManagerEnabled || DynamicVariables.TaskmanagerEnabled) {
                columns.push(
                    { field: 'DueDateValue', headerText: 'Due date', width: 80, allowFiltering: false },
                )
            }

            if(result.officesEnabled) {
                columns.push( 
                { 
                    field: 'OfficeShortName', headerTemplate: '<div class="w-100 mt-2 d-flex justify-content-center" title="Office"><i class="fa-solid fa-building"></i></div>', allowSorting: false, allowFiltering: true, width: 60, 
                        filterBarTemplate: SyncfusionDropdownHelper.templateEnumOptionsDropDown(() => this.workbookGrid, 'OfficeShortName', result.offices, 
                        (args) => {
                        if (args.value !== 'All') {
                            self.workbookGrid.filterByColumn(args.item.parentElement.id.replace('_options', ''), 'equal', args.value, undefined, true);
                        } else {
                            self.workbookGrid.removeFilteredColsByField(args.item.parentElement.id.replace('_options', ''));
                        }
                    
                    })
                });
            }

            columns.push(
                { 
                    field: 'StatusText', allowSorting: false, headerText: 'Status', width: 130, filterBarTemplate: SyncfusionDropdownHelper.templateEnumOptionsDropDown(() => this.workbookGrid, 'StatusText', Object.keys(DocHeaderFilterStatus).filter(key => isNaN(Number(key))), 
                    (args) => {
                    if (args.value !== 'All') {
                        self.workbookGrid.filterByColumn(args.item.parentElement.id.replace('_options', ''), 'equal', args.value, undefined, true);
                    } else {
                        self.workbookGrid.removeFilteredColsByField(args.item.parentElement.id.replace('_options', ''));
                    }
                }), template: '${getDwhStatusField(data.Id, data.Status, data.StatusText, data.CanProcess, data.IsQuoted, data.Discarded, data.ManuallyQuoted)}'},
            )

            self.workbookGrid = new Grid(
                {
                    height: '100%',
                    width: '100%',
                    toolbarTemplate: '#toolbar-template',
                    dataSource: data,
                    columns: columns,
                    allowSorting: true,
                    allowPaging: true,
                    allowFiltering: true,
                    allowSelection: false,
                    allowResizing: false,
                    enablePersistence: true,
                    pageSettings: { pageSize: 50 },

                    created: () => {
                        gridContentElement = gridContentElement.find('.e-content')
        
                        loadingContainer.addClass('d-none');
                        dataWarehouseItemsContainer.removeClass('d-none');
                    },
                    dataBound: () => {
                        gridContentElement.find('[data-bs-toggle="tooltip"]').tooltip({ container: 'body', trigger: 'hover' });
                    },
                    rowDataBound: (args) => {
                        if(args.data['Discarded'] == 'True' || args.data['Discarded'] == 'true' || args.data['Discarded'] == true) {
                            args.row.classList.add('discarded-row');
                        }
                    },
                    
                    actionBegin: (args) => {
                        if (!this.workbookGrid) {
                            return;
                        }

                        if (SyncfusionGridHelper.isFilterAction(args)) {
                            this.workbookGrid.pageSettings.currentPage = 1;
                        }
                    },

                    recordClick: (args: RecordClickEventArgs) => {
                        if (args.target != undefined && args.rowData != undefined) {
                            var parsedTarget = $(args.target); 
                            var documentId = args.rowData["Id"];
                            var revisionId = args.rowData["RevisionId"];
                            var discarded = args.rowData["Discarded"] == true;

                            if(parsedTarget.data('action') == 'finish-dwh-enquiry' || parsedTarget.parent().data('action') == 'finish-dwh-enquiry' && documentId != undefined) {
                                parsedTarget.prop('disabled', true);

                                new ConfirmModal().initialize('Mark as quoted', 'Press confirm to mark this enquiry as quoted.</br>This action cannot be reverted.', () => {
                                    DataWarehouseDataService.markDocHeaderAsQuoted(documentId, (result) => {
                                        self.workbookGrid.filterByColumn("Id", 'equal', `${crypto.randomUUID()}`, undefined, true)
                                        Toastr.Success('Success', 'The document has successfully been marked as quoted');
                                    })
                                }, () => {
                                }, 'Confirm', 'Cancel')
                            } 
                            else if(parsedTarget.data('action') == 'add-project-task-button' || parsedTarget.parent().data('action') == 'add-project-task-button' && documentId != undefined) {
                                parsedTarget.prop('disabled', true);
                                self.addTaskModalHelper.load(`/Company/Workload/Task?docHeaderId=${documentId}&handler=AddOrUpdateTask`, undefined, () => {
                                    if(self.addTaskManager == undefined) {
                                        self.addTaskManager = new AddOrUpdateTaskPopupManager(self.addTaskModalHelper.getModalContainer());
                                    }

                                    self.addTaskManager.initialize();
                                });                    
                            }

                            if(args.column?.field == 'StatusText') {
                                return;
                            }
                        
                            // if(parsedTarget.data('action') == 'sent-to-erp' || parsedTarget.parent().data('action') == 'sent-to-erp' && documentId != undefined) {
                            //     parsedTarget.prop('disabled', true);
        
                            //     DataWarehouseDataService.sentDocHeaderToErp(documentId, revisionId, (result) => {
                            //         Toastr.Success('Success', 'The document has successfully been sent to the ERP');
                            //         self.workbookGrid.filterByColumn("Id", 'equal', `${crypto.randomUUID()}`, undefined, true)
                            //     })
                            // }

                            if((parsedTarget.data('action') == 'create-erp-customer' || parsedTarget.parent().data('action') == 'create-erp-customer') && documentId != undefined && discarded == false) {
                                parsedTarget.prop('disabled', true);

                                self.customerXrefModalHelper.load(`/Company/DataWarehouse/Index?docHeaderId=${documentId}&invokeLocation=DwhIndex&handler=CreateCustomerXref`, undefined, () => {
                                    if(self.createCustomerXrefManager == undefined) {
                                        self.createCustomerXrefManager = new CreateCustomerXrefManager(self.customerXrefModalHelper.getModalContainer());
                                    }
                    
                                    self.createCustomerXrefManager.initialize();
                                }, 
                                undefined);
                            }
                            else if((parsedTarget.data('action') == 'create-erp-vessel' || parsedTarget.parent().data('action') == 'create-erp-vessel') && documentId != undefined && discarded == false) {
                                parsedTarget.prop('disabled', true);
        
                                self.vesselXrefModalHelper.load(`/Company/DataWarehouse/Index?docHeaderId=${documentId}&invokeLocation=DwhIndex&handler=CreateVesselXref`, undefined, () => {
                                    if(self.createVesselXrefManager == undefined) {
                                        self.createVesselXrefManager = new CreateVesselXrefManager(self.vesselXrefModalHelper.getModalContainer());
                                    }
                    
                                    self.createVesselXrefManager.initialize();
                                }, 
                                undefined);
                            }    
                            else if((parsedTarget.data('action') == 'create-erp-department' || parsedTarget.parent().data('action') == 'create-erp-department') && documentId != undefined && discarded == false) {
                                parsedTarget.prop('disabled', true);
        
                                self.departmentXrefModalHelper.load(`/Company/DataWarehouse/Index?docHeaderId=${documentId}&invokeLocation=DwhIndex&handler=CreateDepartmentXref`, undefined, () => {
                                    if(self.createDepartmentXrefManager == undefined) {
                                        self.createDepartmentXrefManager = new CreateDepartmentXrefManager(self.departmentXrefModalHelper.getModalContainer());
                                    }
                    
                                    self.createDepartmentXrefManager.initialize();
                                }, 
                                undefined);
                            }                         
                            else {
                                if(DynamicVariables.AltPressed) {
                                    var field = args.column?.field;
                                    var fieldValue = args.rowData[`${field}`];
 
                                    if(field != undefined && field.length > 0 && fieldValue != undefined && fieldValue.length > 0) {
                                        if(args.column?.filterBarTemplate != undefined) {
                                            if(fieldValue == 'Sent to ERP') {
                                                fieldValue = 'SentToERP'
                                            }
                                            else if(fieldValue == 'Ready to quote') {
                                                fieldValue = 'ReadyToQuote'
                                            }

                                            (args.column?.filterBarTemplate as any).setValue(fieldValue);
                                        }
                                        else {
                                            self.workbookGrid.filterByColumn(field, "equal", fieldValue);
                                        }
                                        
                                    }
                                }
                                else {
                                    var url = `/Company/DataWarehouse/${documentId}/Details`;
                                    if(DynamicVariables.ControlPressed) {
                                        window.open(url, '_blank');
                                    }
                                    else {
                                        location.href = url;
                                    }
                                }

                                
                            }
                        }
                    },
                });

                


                self.workbookGrid.appendTo('#DataWarehouseGrid');


                var docTypeSwitchInputs = self.containerElement.find('#doc-header-doc-type-container input');
                docTypeSwitchInputs.each((index, element) => {
                    var docTypeSwitchInput = $(element);
                    

                    docTypeSwitchInput.off('click').on('click', () => {
                        var selectedDocType : any = docTypeSwitchInput.val()?.toString();  

                        // if(selectedDocType != '') {
                        //     self.workbookGrid.hideColumns('DocType', 'field');
                        // }
                        // else {
                        //     self.workbookGrid.showColumns('DocType', 'field');
                        // }

                        self.workbookGrid.filterByColumn('DocType', "equal", selectedDocType); 
                    }); 
                })
                
        
                var toolbar = this.containerElement.find('#toolbar-template');
                if(toolbar != undefined && toolbar.length > 0) {
                    var addButton = toolbar.find('#add-button');
                    addButton.off('click').on('click', () => {
                        self.addManualProjectModalHelper.load(`?handler=AddManualProject`, undefined, () => {
                            if(self.addManualProjectManager == undefined) {
                                self.addManualProjectManager = new AddManualProjectManager(self.addManualProjectModalHelper.getModalContainer());
                            }
            
                            self.addManualProjectManager.initialize();
                        }, 
                        undefined);
                    })

                    var clearFiltersButton = toolbar.find('#clear-filters-button');
                    clearFiltersButton.off('click').on('click', () => {
                        assignedToMeCheckbox.prop('checked', false);
                        overdueOnlyChecked.prop('checked', false);
                        showDiscardedCheckbox.prop('checked', false);

                        self.workbookGrid.pageSettings.currentPage = 1;
                        self.workbookGrid.clearFiltering();
                        self.workbookGrid.refreshHeader();
                    })
                }

                const columnsToShow = new Set([
                    'CustomerName',
                    'VesselName',
                    'Deparment',
                    'CustomerReference',
                    'OurReference'
                ]);

                const workbookColumns = this.workbookGrid.getColumns() as Column[];

                const visibleColumnIndexesToShow = new Set<number>();

                workbookColumns.forEach((column, index) => {
                    if (columnsToShow.has(column.field)) {
                        visibleColumnIndexesToShow.add(index + 1);
                    }
                });

                let tooltip: Tooltip = new Tooltip({
                    target: ".e-rowcell", 
                    openDelay: 400,
                    beforeRender: (args: TooltipEventArgs) => {
                        var text = args.target.innerText;
                        if(text == undefined || text.length <= 0) {
                            args.cancel = true;
                            return;
                        }

                        const cell = args.target as HTMLElement;
                        const ariaColIndex = Number(cell.getAttribute('aria-colindex'));

                        if (!visibleColumnIndexesToShow.has(ariaColIndex)) {
                            args.cancel = true;
                            return;
                        }

                        if (args.target.classList.contains('e-rowcell')) {
                            tooltip.content = args.target.innerText;
                        }
                    }
                });
                tooltip.appendTo('#DataWarehouseGrid');
        });


        (<any>window).initializeAddManualProject = () => {
            if(self.addManualProjectModalHelper.getModalContainer().find('.alert-danger').length == 0) {
                self.workbookGrid.refresh();
            }
            else {
                self.addManualProjectManager.initialize();
            }
        }

        (<any>window).initializeCreateCustomerXref = () => {
            if(self.customerXrefModalHelper.getModalContainer().find('.alert-danger').length == 0) {
                self.workbookGrid.refresh();
            }
            else {
                self.createCustomerXrefManager.initialize();
            }
        }        
        
        (<any>window).initializeCreateVesselXref = () => {
            if(self.vesselXrefModalHelper.getModalContainer().find('.alert-danger').length == 0) {
                self.workbookGrid.refresh();
            }
            else {
                self.createVesselXrefManager.initialize();
            }
        }        
        
        (<any>window).initializeCreateDepartmentXref = () => {
            if(self.departmentXrefModalHelper.getModalContainer().find('.alert-danger').length == 0) {
                self.workbookGrid.refresh();
            }
            else {
                self.createDepartmentXrefManager.initialize();
            }
        }

        (<any>window).initializeAddOrUpdateTask = () => {
            if(self.addTaskModalHelper.getModalContainer().find('.alert-danger').length == 0) {
                self.workbookGrid.refresh();
            }
            else {
                self.addTaskManager.initialize();
            }
        }

        assignedToMeCheckbox.off('change').on('change', () => {
            self.workbookGrid.filterByColumn('AssignedToMe', "equal", assignedToMeCheckbox.is(":checked"));
            //self.workbookGrid.refresh();
        })        
        
        overdueOnlyChecked.off('change').on('change', () => {
            self.workbookGrid.filterByColumn('OnlyOverdue', "equal", overdueOnlyChecked.is(":checked"));
            //self.workbookGrid.refresh();
        })        
        
        showDiscardedCheckbox.off('change').on('change', () => {
            self.workbookGrid.filterByColumn('ShowDiscarded', "equal", showDiscardedCheckbox.is(":checked"));
            //self.workbookGrid.refresh();
        })
    }
}